import React, { useState, useRef, useEffect } from "react";
import CarouselCard from "./CarouselCard";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const Carousel = ({ projects, isLarge, autoSlide }) => {
  const carouselRef = useRef(null);

  const [isFirstCard, setIsFirstCard] = useState(true);
  const [isLastCard, setIsLastCard] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handlePrevClick = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft -= 300; // Adjust the scroll distance as needed
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current) {
      const maxScroll =
        carouselRef.current.scrollWidth - carouselRef.current.clientWidth;
      const newScrollLeft = carouselRef.current.scrollLeft + 300; // Adjust the scroll distance as needed
      console.log(newScrollLeft, maxScroll);
      if (newScrollLeft >= maxScroll + 300) {
        // If at the last card, scroll back to the first card
        carouselRef.current.scrollLeft = 0;
      } else {
        carouselRef.current.scrollLeft = newScrollLeft;
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (carouselRef.current) {
        const scrollLeft = carouselRef.current.scrollLeft;
        const maxScroll =
          carouselRef.current.scrollWidth - carouselRef.current.clientWidth;

        setIsFirstCard(scrollLeft === 0);
        setIsLastCard(scrollLeft >= maxScroll - 1); // Adjust for potential rounding issues

        setScrollPosition(scrollLeft / maxScroll);
      }
    };

    if (carouselRef.current) {
      carouselRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (carouselRef.current) {
        carouselRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [carouselRef]);

  useEffect(() => {
    let interval;

    if (!isHovered && autoSlide) {
      interval = setInterval(() => {
        handleNextClick();
      }, 10000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isHovered]);
  return (
    <div
      className="group relative -my-4 overflow-hidden scroll"
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <div
        className="flex h-full items-stretch overflow-y-hidden overflow-x-scroll scroll-smooth py-3 scrollbar-hide snap-x snap-mandatory"
        style={{
          marginLeft: "-16px",
          paddingRight: 0,
        }}
        ref={carouselRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {projects?.map((p, index) => (
          <CarouselCard p={p} isLarge={isLarge} />
        ))}
        {isHovered && (
          <div className="opacity-100 transition-opacity group-hover:opacity-100 sm:block">
            <div
              className={`absolute left-2 top-1/2 flex -translate-y-1/2 transition-opacity ${
                isFirstCard ? "opacity-20" : "opacity-100"
              }`}
              onClick={handlePrevClick}
            >
              <div
                role="button"
                tabindex="0"
                className={`flex p-[0.4375rem] items-center justify-center rounded-full border border-neutral-20 bg-neutral-0 text-neutral-100 transition-colors hover:bg-neutral-5 active:bg-neutral-10 dark:border-neutral-80 dark:bg-neutral-100 dark:hover:bg-neutral-95 dark:active:bg-neutral-90 dark:text-neutral-0 ${
                  isFirstCard ? "pointer-events-none" : "pointer-events-auto"
                }`}
                aria-label="Scroll left"
              >
                <FaChevronLeft />
              </div>
            </div>
            <div
              className={`absolute right-2 top-1/2 flex -translate-y-1/2 transition-opacity ${
                isLastCard ? "opacity-20" : "opacity-100"
              }`}
              onClick={handleNextClick}
            >
              <div
                role="button"
                tabindex="0"
                className={`flex p-[0.4375rem] items-center justify-center rounded-full border border-neutral-20 bg-neutral-0 text-neutral-100 transition-colors hover:bg-neutral-5 active:bg-neutral-10 dark:border-neutral-80 dark:bg-neutral-100 dark:hover:bg-neutral-95 dark:active:bg-neutral-90 dark:text-neutral-0 ${
                  isLastCard ? "pointer-events-none" : "pointer-events-auto"
                }`}
                aria-label="Scroll right"
              >
                <FaChevronRight />
              </div>
            </div>
          </div>
        )}
        <div className="absolute h-1 w-10 rounded-full bg-neutral-10 opacity-100 transition-opacity group-hover:opacity-100 dark:bg-neutral-90 right-0 top-1 hover:opacity-100">
          <div
            className="h-full rounded-full bg-neutral-100 transition-width dark:bg-neutral-0"
            style={{ width: `${scrollPosition * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
